import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, saveToken } from '../api';
import { useAppContext } from '../context/AppContext';

export default function RegisterScreen() {
  const navigate = useNavigate();
  const { loadUserProfile } = useAppContext();
  const [form, setForm] = useState({ name: '', email: '', phone: '', password: '', confirmPassword: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [confirming, setConfirming] = useState(false);
  const [otp, setOtp] = useState('');
  const [otpError, setOtpError] = useState('');
  const [verifying, setVerifying] = useState(false);
  const [resending, setResending] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem('register_form');
    if (saved) { try { const d = JSON.parse(saved); setForm(p => ({ ...p, name: d.name || '', email: d.email || '', phone: d.phone || '' })); } catch {} }
  }, []);

  const updateField = (field, value) => {
    setForm(p => ({ ...p, [field]: value }));
    if (errors[field]) setErrors(p => ({ ...p, [field]: null }));
    if (['name', 'email', 'phone'].includes(field)) {
      const cur = { ...form, [field]: value };
      localStorage.setItem('register_form', JSON.stringify({ name: cur.name, email: cur.email, phone: cur.phone }));
    }
  };

  const handlePhoneChange = (value) => {
    let c = value.replace(/[^\d+]/g, '');
    if (c.startsWith('8')) c = '+7' + c.slice(1);
    if (c.startsWith('7') && !c.startsWith('+7')) c = '+' + c;
    if (c.length > 12) return;
    updateField('phone', c);
  };

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = 'Введите имя';
    else if (!/^[a-zA-Zа-яёА-ЯЁ]/.test(form.name.trim())) e.name = 'Имя должно начинаться с буквы';
    if (!form.email.trim()) e.email = 'Введите email';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = 'Некорректный email';
    if (!form.phone.trim()) e.phone = 'Введите телефон';
    else if (!/^\+7\d{10}$/.test(form.phone)) e.phone = 'Формат: +79991234567';
    if (!form.password) e.password = 'Введите пароль';
    else if (form.password.length < 6) e.password = 'Минимум 6 символов';
    if (!form.confirmPassword) e.confirmPassword = 'Подтвердите пароль';
    else if (form.password !== form.confirmPassword) e.confirmPassword = 'Пароли не совпадают';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    try {
      await api.auth.register({ name: form.name.trim(), email: form.email, phone: form.phone, password: form.password });
      localStorage.removeItem('register_form');
      setConfirming(true);
    } catch (err) {
      setErrors(p => ({ ...p, email: err.detail?.includes('уже зарегистрирован') ? 'Этот email уже зарегистрирован' : (err.detail || 'Нет соединения с сервером') }));
    } finally { setLoading(false); }
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    const code = otp.trim();
    if (code.length < 6) { setOtpError('Введите 6-значный код'); return; }
    setVerifying(true); setOtpError('');
    try {
      const data = await api.auth.verify({ email: form.email, code });
      saveToken(data.access_token);
      await loadUserProfile();
    } catch (err) {
      setOtpError(err.detail || 'Неверный или устаревший код');
    } finally { setVerifying(false); }
  };

  const handleResend = async () => {
    setResending(true);
    try {
      await api.auth.register({ name: form.name.trim(), email: form.email, phone: form.phone, password: form.password });
      setOtp(''); setOtpError('');
      alert('Новый код отправлен на вашу почту');
    } catch { alert('Нет соединения с сервером'); }
    finally { setResending(false); }
  };

  if (confirming) {
    return (
      <div style={{ padding: 24, minHeight: '100vh' }}>
        <button onClick={() => setConfirming(false)} style={{ background: 'none', color: 'var(--primary)', fontSize: 16, marginTop: 8, marginBottom: 16 }}>← Назад</button>
        <div style={{ textAlign: 'center', padding: '40px 0' }}>
          <div style={{ fontSize: 56, marginBottom: 16 }}>📧</div>
          <h2 style={{ fontSize: 22, fontWeight: 700, color: 'var(--text)', marginBottom: 8 }}>Подтвердите email</h2>
          <p style={{ fontSize: 15, color: 'var(--text-light)', lineHeight: 1.5 }}>
            Мы отправили 6-значный код на<br />
            <span style={{ fontWeight: 700, color: 'var(--text)' }}>{form.email}</span>
          </p>
        </div>
        <form onSubmit={handleVerify} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <label style={labelStyle}>Код подтверждения</label>
          <input
            type="text" placeholder="000000" maxLength={6}
            value={otp} onChange={e => { setOtp(e.target.value.replace(/\D/g, '').slice(0, 6)); setOtpError(''); }}
            style={{ ...inputStyle, fontSize: 28, fontWeight: 700, textAlign: 'center', letterSpacing: 8, borderColor: otpError ? '#FF3B30' : 'var(--border)' }}
          />
          {otpError && <p style={errorStyle}>⚠ {otpError}</p>}
          <button type="submit" disabled={verifying || otp.length < 6} style={{ ...btnStyle, opacity: (verifying || otp.length < 6) ? 0.6 : 1 }}>
            {verifying ? 'Проверка...' : 'Подтвердить'}
          </button>
          <div style={{ textAlign: 'center', paddingTop: 16 }}>
            <span onClick={handleResend} style={{ color: 'var(--primary)', fontSize: 15, cursor: 'pointer' }}>
              {resending ? 'Отправка...' : 'Не получили код? Отправить снова'}
            </span>
          </div>
        </form>
      </div>
    );
  }

  return (
    <div style={{ padding: 24, minHeight: '100vh' }}>
      <h1 style={{ fontSize: 28, fontWeight: 'bold', color: 'var(--primary)', marginTop: 40 }}>Регистрация</h1>
      <p style={{ fontSize: 16, color: 'var(--text-light)', marginBottom: 24 }}>Создайте аккаунт для заказа воды</p>
      <form onSubmit={handleRegister} style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        <Field label="Имя" placeholder="Алексей Иванов" value={form.name} onChange={e => updateField('name', e.target.value)} error={errors.name} />
        <Field label="Email" type="email" placeholder="example@mail.ru" value={form.email} onChange={e => updateField('email', e.target.value)} error={errors.email} />
        <Field label="Телефон" type="tel" placeholder="+79991234567" value={form.phone} onChange={e => handlePhoneChange(e.target.value)} error={errors.phone} />
        <Field label="Пароль" type="password" placeholder="Минимум 6 символов" value={form.password} onChange={e => updateField('password', e.target.value)} error={errors.password} />
        <Field label="Подтвердите пароль" type="password" placeholder="Повторите пароль" value={form.confirmPassword} onChange={e => updateField('confirmPassword', e.target.value)} error={errors.confirmPassword} />
        <button type="submit" disabled={loading} style={{ ...btnStyle, opacity: loading ? 0.6 : 1, marginTop: 8 }}>
          {loading ? 'Отправка...' : 'Зарегистрироваться'}
        </button>
      </form>
      <div style={{ textAlign: 'center', paddingTop: 24 }}>
        <span onClick={() => navigate('/login')} style={{ color: 'var(--primary)', fontSize: 16, cursor: 'pointer' }}>Уже есть аккаунт? Войти</span>
      </div>
      <p style={{ textAlign: 'center', fontSize: 13, color: 'var(--text-light)', marginTop: 16, lineHeight: 1.5 }}>
        Нажимая «Зарегистрироваться», вы соглашаетесь с{' '}
        <a href="https://api.watertgdelivery.ru/privacy" target="_blank" rel="noreferrer" style={{ color: 'var(--primary)', textDecoration: 'underline' }}>Политикой конфиденциальности</a>
      </p>
    </div>
  );
}

function Field({ label, error, ...props }) {
  return (
    <div style={{ marginBottom: 16 }}>
      <label style={labelStyle}>{label}</label>
      <input style={{ ...inputStyle, borderColor: error ? '#FF3B30' : 'var(--border)' }} {...props} />
      {error && <p style={errorStyle}>⚠ {error}</p>}
    </div>
  );
}

const labelStyle = { display: 'block', fontSize: 15, fontWeight: 600, color: 'var(--text)', marginBottom: 6 };
const inputStyle = { display: 'block', width: '100%', backgroundColor: 'var(--input-bg)', borderRadius: 12, padding: '12px 16px', fontSize: 15, color: 'var(--text)', border: '1.5px solid var(--border)', outline: 'none' };
const errorStyle = { fontSize: 13, color: '#FF3B30', marginTop: 4 };
const btnStyle = { display: 'block', width: '100%', backgroundColor: 'var(--primary)', padding: 14, borderRadius: 14, color: '#FFF', fontSize: 16, fontWeight: 700 };
